import { useState } from 'react';

function useLocalStorage(key, initialValue) {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            return initialValue;
        }
    });

    const setValue = (value) => {
        try {
            const item = window.localStorage.getItem(key);
            let current = item ? new Set(JSON.parse(item)) : new Set();
            current = [...current, value];
            setStoredValue(current);
            window.localStorage.setItem(key, JSON.stringify(current));
        } catch (error) {
            console.log(error);
        }
    };

    const clearStorage = () => {
        window.localStorage.removeItem(key);
    };

    return [storedValue, setValue, clearStorage];
}

export default useLocalStorage;
